import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import useStyles from './styles';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Divider, Menu } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Icon } from '@livable/saas-react-components';
// import { useStore } from 'src/stores';

export const PortfoliosMenu = observer(_ref => {
  _objectDestructuringEmpty(_ref);
  // const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    className: classes.todoDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '000-portfolios-page-menu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "dotdotdot"
  })), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {}
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "building-plus"
  }), t('Add property')), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {}
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "building-plus"
  }), t('Create new property')), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {}
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "move-in"
  }), t('Enroll resident')), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {}
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "team-group"
  }), t('Manage access')), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {}
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('Rename')), /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: () => {}
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  }), t('Delete portfolio'))));
});